import BaseAPI from './base'

class ExerciseFavoriteAPI extends BaseAPI {}

export default new ExerciseFavoriteAPI('v1/favorite-exercise-store', 'ExerciseFavorite')
